import { render } from "./StaffSettings.vue?vue&type=template&id=b3735e60&scoped=true"
import script from "./StaffSettings.vue?vue&type=script&lang=js"
export * from "./StaffSettings.vue?vue&type=script&lang=js"

import "./StaffSettings.vue?vue&type=style&index=0&id=b3735e60&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3735e60"]])

export default __exports__